'use client';

import React from 'react';

const actions = [
  {
    icon: '📞',
    title: 'Call Now',
    subtitle: '(505) 910-2846',
    desc: 'Speak directly with our team',
    href: 'tel:5059102846',
    bg: 'from-teal to-teal-dark',
    external: false,
  },
  {
    icon: '💬',
    title: 'Text Us',
    subtitle: 'Quick Response',
    desc: 'Send us a message anytime',
    href: 'sms:5059102846',
    bg: 'from-slate-700 to-slate-900',
    external: false,
  },
  {
    icon: '📅',
    title: 'Check Availability',
    subtitle: 'Book Online',
    desc: 'Schedule your appointment now',
    href: 'https://riograndepropertysolutions.booksy.com/a/',
    bg: 'from-teal-dark to-teal',
    external: true,
  },
];

export default function RGPSQuickActions() {
  return (
    <section className="bg-white py-8 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
        {actions?.map((action) => (
          <a
            key={action?.title}
            href={action?.href}
            target={action?.external ? '_blank' : undefined}
            rel={action?.external ? 'noopener noreferrer' : undefined}
            className={`group relative overflow-hidden bg-gradient-to-br ${action?.bg} rounded-2xl p-6 text-white flex items-center gap-4 shadow-card-lg hover:scale-[1.02] transition-all duration-300`}
          >
            <div className="text-4xl flex-shrink-0">{action?.icon}</div>
            <div>
              <div className="font-bold text-lg leading-tight">{action?.title}</div>
              <div className="text-white/90 font-semibold text-sm">{action?.subtitle}</div>
              <div className="text-white/70 text-xs mt-0.5">{action?.desc}</div>
            </div>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-30 group-hover:opacity-60 transition-opacity">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
